import React from 'react';

type ActiveTypes = 'active' | 'completed' | 'inactive';

type Props = {
  stepCount: number;
  isLastPage: boolean;
};

export default function Timeline({ stepCount, isLastPage }: Props) {
  const activeClasses: Record<ActiveTypes, string> = {
    active: 'text-primary-900 text-lg',
    completed: 'text-primary-900',
    inactive: 'border-[#979797]'
  };
  const activeTextClasses: Record<ActiveTypes, string> = {
    active: 'border-primary-900 text-[#353535]',
    completed: 'border-primary-900 bg-primary-900 text-white',
    inactive: 'border-[#979797]'
  };

  return (
    <ol className="flex w-full items-center text-center text-sm font-medium text-[#353535] sm:text-base">
      <li
        className={`after:border-1 flex items-center after:mx-3 after:hidden after:h-1 after:w-full after:border-b-4 after:border-[#3E3E3E80] sm:after:inline-block sm:after:content-[''] md:w-full ${
          activeClasses[stepCount > 1 ? 'completed' : 'active']
        }`}
      >
        <span className="flex items-center after:mx-2 after:text-gray-200 after:content-['/'] sm:after:hidden">
          <span
            className={`mr-3 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 ${
              activeTextClasses[stepCount > 1 ? 'completed' : 'active']
            }`}
          >
            1
          </span>
          Personal{' '}
          <span className="hidden sm:ml-2 sm:inline-flex">Information</span>
        </span>
      </li>
      <li
        className={`after:border-1 flex items-center after:mx-3 after:hidden after:h-1 after:w-full after:border-b-4 after:border-[#3E3E3E80] after:content-[''] sm:after:inline-block md:w-full ${
          activeClasses[
            stepCount > 2
              ? 'completed'
              : stepCount === 1
              ? 'inactive'
              : 'active'
          ]
        }`}
      >
        <span className="flex items-center after:mx-2 after:text-gray-200 after:content-['/'] sm:after:hidden">
          <span
            className={`mr-3 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 ${
              activeTextClasses[
                stepCount > 2
                  ? 'completed'
                  : stepCount === 1
                  ? 'inactive'
                  : 'active'
              ]
            }`}
          >
            2
          </span>
          Financial{' '}
          <span className="hidden sm:ml-2 sm:inline-flex">Information</span>
        </span>
      </li>
      <li className="flex items-center">
        <span
          className={`mr-3 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 ${
            activeTextClasses[
              stepCount === 3
                ? isLastPage
                  ? 'completed'
                  : 'active'
                : 'inactive'
            ]
          }`}
        >
          3
        </span>
        Other
        <span className="hidden sm:ml-2 sm:inline-flex">Information</span>
      </li>
    </ol>
  );
}
